// Arrows, dots and optional thumbnails for every .lp-carousel: the shop's
// photos, the before/after and founder cards, the top reviews' proof cards
// and the review viewer. A carousel's data-lp-carousel-item names what its
// dots count (default Photo); a carousel without a dots strip has none. The
// track is a CSS scroll-snap strip; this only scrolls it and mirrors the
// current slide onto the dots and the thumbs (one .lp-carousel__thumb per
// slide, in track order), and once the track rests it scrolls the thumb strip
// to show the current thumb. A step is the distance from one slide to the
// next, the track's width when the slides fill it, less when they peek. Runs
// once per carousel even if a page includes this file twice, on carousels
// mounted by lp:mount, and on carousels drawn later that dispatch lp:content.
//
// A mouse drags every track, and every other strip marked data-lp-drag (the
// all reviews' media strip), 1:1 with the pointer; touch and pen keep the
// browser's own scrolling. The first 8 px decide: mostly sideways drags the
// track, mostly up or down leaves the press alone, so the review viewer's
// pull down still closes it. On release the track glides to the nearest
// slide by the arrows' step, a flick at least one slide its way, and a track
// whose slides stop every scroll (scroll-snap-stop: always, the viewer) moves
// one slide at most. A press that travels past 6 px swallows the click that
// follows, so a drag never opens a card. A press on something that drags
// itself (a slider such as the compare handle, a field, a video's controls)
// is left to it. data-lp-drag-state is grab over a strip that can scroll,
// grabbing while it drags, and settling while it glides, which turns the
// snap off until it rests.
(function () {
  var DECIDE_PX = 8;
  var CLICK_SLOP_PX = 6;
  var FLICK_PX_PER_MS = 0.4;
  var FLICK_WINDOW_MS = 100;
  var REST_MS = 120;
  var VIDEO_CONTROLS_PX = 64;
  var DRAGS_ITSELF = 'input, textarea, select, [contenteditable], [role="slider"]';

  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  }
  function pitch(track) {
    var slides = track.children;
    return (slides.length > 1 && slides[1].offsetLeft - slides[0].offsetLeft) || track.clientWidth;
  }
  function goTo(track, index) {
    var clamped = Math.max(0, Math.min(track.children.length - 1, index));
    track.scrollTo({ left: clamped * pitch(track), behavior: scrollBehavior() });
  }

  function drag(track) {
    if (track.dataset.lpDragReady) return;
    track.dataset.lpDragReady = 'true';
    var press = null;
    var phase = null;
    var swallow = false;
    var rest = 0;
    function state(value) {
      phase = value;
      if (value) track.setAttribute('data-lp-drag-state', value);
      else track.removeAttribute('data-lp-drag-state');
    }
    function scrollable() {
      return track.scrollWidth > track.clientWidth;
    }
    function idle() {
      state(scrollable() ? 'grab' : null);
    }
    function drivesItself(event) {
      if (event.target.closest(DRAGS_ITSELF)) return true;
      var clip = event.target.closest('video[controls]');
      return Boolean(clip) && event.clientY > clip.getBoundingClientRect().bottom - VIDEO_CONTROLS_PX;
    }
    function speed(ended, now) {
      var recent = ended.samples.filter(function (sample) { return now - sample.t <= FLICK_WINDOW_MS; });
      if (recent.length < 2) return 0;
      var first = recent[0];
      var last = recent[recent.length - 1];
      return (last.x - first.x) / Math.max(last.t - first.t, 1);
    }
    function move(event) {
      if (event.pointerId !== press.id) return;
      if (event.buttons === 0) return end(event);
      var dx = event.clientX - press.x;
      var dy = event.clientY - press.y;
      if (Math.hypot(dx, dy) > CLICK_SLOP_PX) press.moved = true;
      if (!press.axis) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < DECIDE_PX) return;
        press.axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        if (press.axis === 'x') {
          clearTimeout(rest);
          state('grabbing');
          track.setPointerCapture(event.pointerId);
        }
      }
      if (press.axis !== 'x') return;
      press.samples.push({ x: event.clientX, t: event.timeStamp });
      var left = press.left - dx;
      if (press.oneAtATime) left = Math.max((press.from - 1) * press.step, Math.min((press.from + 1) * press.step, left));
      track.scrollLeft = left;
    }
    function end(event) {
      if (event.pointerId !== press.id) return;
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', end);
      document.removeEventListener('pointercancel', end);
      var ended = press;
      press = null;
      if (ended.moved) {
        swallow = true;
        setTimeout(function () { swallow = false; }, 0);
      }
      if (ended.axis !== 'x') return;
      ended.samples.push({ x: event.clientX, t: event.timeStamp });
      var velocity = speed(ended, event.timeStamp);
      var at = track.scrollLeft / ended.step;
      var index = Math.abs(velocity) < FLICK_PX_PER_MS ? Math.round(at) : velocity < 0 ? Math.ceil(at - 0.01) : Math.floor(at + 0.01);
      state('settling');
      goTo(track, index);
      rest = setTimeout(idle, REST_MS);
    }
    track.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse' && !press && phase !== 'settling') idle();
    });
    track.addEventListener('pointerdown', function (event) {
      if (press || event.pointerType !== 'mouse' || event.button !== 0 || !scrollable() || drivesItself(event)) return;
      var step = pitch(track);
      press = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        left: track.scrollLeft,
        step: step,
        from: Math.round(track.scrollLeft / step),
        oneAtATime: getComputedStyle(track.children[0]).scrollSnapStop === 'always',
        axis: null,
        moved: false,
        samples: [{ x: event.clientX, t: event.timeStamp }],
      };
      // No mouse events follow, so the press selects no text, drags no image
      // ghost and, in Safari, never autoscrolls the track back to the pointer.
      event.preventDefault();
      document.addEventListener('pointermove', move);
      document.addEventListener('pointerup', end);
      document.addEventListener('pointercancel', end);
    });
    // The settle glides by scroll events; the snap comes back once they stop.
    track.addEventListener('scroll', function () {
      if (phase !== 'settling') return;
      clearTimeout(rest);
      rest = setTimeout(idle, REST_MS);
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (!swallow) return;
      swallow = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function init(carousel) {
    if (carousel.dataset.lpCarouselReady) return;
    carousel.dataset.lpCarouselReady = 'true';
    var track = carousel.querySelector('.lp-carousel__track');
    var dots = carousel.querySelector('.lp-carousel__dots');
    var thumbs = carousel.querySelector('.lp-carousel__thumbs');
    var slides = track.children;
    var count = slides.length;
    // Composite slides use their actual content as a miniature, so the
    // thumbnail never drifts from the gifts, reviews or timeline it opens.
    if (thumbs) {
      var miniatures = [];
      Array.prototype.forEach.call(thumbs.children, function (thumb, i) {
        if (thumb.querySelector('img') || !slides[i]) return;
        thumb.setAttribute('aria-label', thumb.textContent.trim());
        var miniature = slides[i].cloneNode(true);
        miniature.classList.add('lp-carousel__miniature');
        miniature.setAttribute('aria-hidden', 'true');
        miniature.setAttribute('inert', '');
        [miniature].concat(Array.from(miniature.querySelectorAll('*'))).forEach(function (node) {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
        });
        thumb.replaceChildren(miniature);
        thumb.classList.add('lp-carousel__thumb--visual');
        miniatures.push({ thumb: thumb, slide: slides[i], miniature: miniature });
      });
      function sizeMiniatures() {
        miniatures.forEach(function (item) {
          var width = item.slide.clientWidth;
          var height = item.slide.clientHeight;
          if (!width || !height) return;
          var scale = Math.min(item.thumb.clientWidth / width, item.thumb.clientHeight / height);
          var sourceStyle = getComputedStyle(item.slide);
          ['padding', 'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing', 'textAlign'].forEach(function (property) {
            item.miniature.style[property] = sourceStyle[property];
          });
          item.miniature.style.width = width + 'px';
          item.miniature.style.height = height + 'px';
          item.miniature.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
        });
      }
      sizeMiniatures();
      var miniatureObserver = new ResizeObserver(sizeMiniatures);
      miniatureObserver.observe(track);
      miniatureObserver.observe(thumbs);
      document.addEventListener('lp:unmount', function cleanup() {
        miniatureObserver.disconnect();
        document.removeEventListener('lp:unmount', cleanup);
      });
    }
    if (count < 2) return;
    drag(track);
    function current() {
      var step = pitch(track);
      return step ? Math.round(track.scrollLeft / step) : 0;
    }
    // Scrolls the strip, never the page, to the nearest snap point that shows
    // the current thumb whole, so proximity snapping leaves it there.
    function revealThumb() {
      var items = thumbs.children;
      var index = current();
      var strip = thumbs.getBoundingClientRect();
      var gutter = parseFloat(getComputedStyle(thumbs).scrollPaddingLeft) || 0;
      var left = strip.left + gutter;
      var right = strip.right - gutter;
      var thumb = items[index].getBoundingClientRect();
      if (thumb.left >= left && thumb.right <= right) return;
      var anchor = index;
      while (thumb.right > right && anchor > 0 && thumb.right - items[anchor - 1].getBoundingClientRect().left <= right - left) anchor--;
      thumbs.scrollBy({ left: items[anchor].getBoundingClientRect().left - left, behavior: scrollBehavior() });
    }
    function markSelected(tabs, index) {
      Array.prototype.forEach.call(tabs, function (tab, i) {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
    var prev = carousel.querySelector('.lp-carousel__arrow--prev');
    var next = carousel.querySelector('.lp-carousel__arrow--next');
    function sync() {
      var index = current();
      if (dots) markSelected(dots.children, index);
      if (thumbs) markSelected(thumbs.children, index);
      var scrolls = track.scrollWidth > track.clientWidth;
      var atEnd = index === count - 1 || (scrolls && track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
      carousel.toggleAttribute('data-lp-at-start', index === 0);
      carousel.toggleAttribute('data-lp-at-end', atEnd);
      // A hidden arrow drops its focus to the page, so the other arrow takes it.
      if (index === 0 && prev && document.activeElement === prev) next.focus({ preventScroll: true });
      if (atEnd && next && document.activeElement === next) prev.focus({ preventScroll: true });
    }
    for (var i = 0; dots && i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lp-carousel__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', (carousel.dataset.lpCarouselItem || 'Photo') + ' ' + (i + 1) + ' of ' + count);
      dot.addEventListener('click', goTo.bind(null, track, i));
      dots.appendChild(dot);
    }
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.children, function (thumb, i) {
        thumb.addEventListener('click', goTo.bind(null, track, i));
      });
    }
    if (prev) prev.addEventListener('click', function () { goTo(track, current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(track, current() + 1); });
    // A thumb tap runs the track through every slide in between, so the strip
    // follows only the slide the track comes to rest on.
    var settle;
    track.addEventListener('scroll', function () {
      sync();
      if (!thumbs) return;
      clearTimeout(settle);
      settle = setTimeout(revealThumb, 100);
    }, { passive: true });
    sync();
  }
  function initAll() {
    document.querySelectorAll('.lp-carousel').forEach(init);
    document.querySelectorAll('[data-lp-drag]').forEach(drag);
  }
  initAll();
  document.addEventListener('lp:mount', initAll);
  // Markup drawn after load (assets/lp-reviews.js) announces itself.
  document.addEventListener('lp:content', function (event) {
    if (event.target.matches('.lp-carousel')) init(event.target);
    event.target.querySelectorAll('.lp-carousel').forEach(init);
    if (event.target.matches('[data-lp-drag]')) drag(event.target);
    event.target.querySelectorAll('[data-lp-drag]').forEach(drag);
  });
})();
